module.exports = __webpack_public_path__ + "static/media/atlassian.cd941eec.png";